import { HTTPMethod } from '../../types/enums';
import { AdapterInterface } from '../../types/global';

import BaseAdapter from './baseAdapter';

export default class PostDeleteCohort extends BaseAdapter<void> implements AdapterInterface {
  rawResponse: void;

  modifiedRequest: { cohort_id: number };

  async adaptResponse(request: string): Promise<void> {
    const formattedRequest = this.adaptRequest(request);

    await this.fetchApiResponse('/api/delete-cohort', HTTPMethod.Post, formattedRequest);

    return this.rawResponse;
  }

  adaptRequest(request: string): { cohort_id: number } {
    this.modifiedRequest = { cohort_id: Number(request) };
    return this.modifiedRequest;
  }
}
